import React from "react";

import SearchInput from "../common/search_input/SearchInput";
import ToolsTabs from "../clients/Tools/kit/ToolsTabs";
import ToolsPageHeader from "../clients/Tools/kit/ToolsPageHeader";
import UtilityService from "../../services/UtilityService";
import PlaybookCategoryIcon from "./PlaybookCategoryIcon";

import "./playbook-category-view.css";

const KIND_TABS = [
	{ key: "all", label: "All" },
	{ key: "builtin", label: "Built-in" },
	{ key: "custom", label: "Custom" },
];

class PlaybookCategoryView extends React.PureComponent {
	render() {
		const {
			category,
			onBack,
			action,
			singular,
			totalCount,
			shownCount,
			search,
			onSearch,
			kind,
			onKind,
			filters,
			isNarrowed,
			emptyText,
			onClearNarrowing,
		} = this.props;
		const { children } = this.props;

		return (
			<section className="playbook-category-view">
				<ToolsPageHeader
					compact
					onBack={onBack}
					backLabel="All categories"
					lead={<PlaybookCategoryIcon icon={category.icon} size="large" />}
					title={category.name}
					subtitle={category.description}
					actions={action}
				/>
				{totalCount > 0 && (
					<div className="tk-toolbar">
						<span className="tk-toolbar__count">{UtilityService.describeCount({ count: totalCount, singular })}</span>
						<SearchInput value={search} onChange={event => onSearch({ search: event.target.value })} placeholder={`Search ${singular}s`} />
						{filters}
						<span className="tk-toolbar__end">
							<ToolsTabs segmented tabs={KIND_TABS} activeKey={kind} onSelect={value => onKind({ kind: value })} />
						</span>
					</div>
				)}
				{totalCount === 0 && <div className="tk-card playbook-category-view__empty">{emptyText}</div>}
				{totalCount > 0 && shownCount === 0 && (
					<div className="tk-card playbook-category-view__empty">
						No {singular}s match.{" "}
						<button type="button" className="tk-text-action" onClick={onClearNarrowing}>
							Show all {totalCount}
						</button>
					</div>
				)}
				{shownCount > 0 && children}
				{isNarrowed && shownCount > 0 && (
					<div className="playbook-category-view__narrowed-note">
						Showing {shownCount} of {totalCount}.
					</div>
				)}
			</section>
		);
	}
}

export default PlaybookCategoryView;
